import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { Subscriber } from 'shell/models/subscriber';

export interface transformSubsciberResponse {
  id?: string | number;
  code?: string;
  description?: string;
}

export const transformSubscriber = (
  response: AxiosResponse<HttpResponse<Subscriber>>
): transformSubsciberResponse => {
  const data: Subscriber = response.data.payload || {};
  const res: transformSubsciberResponse = {
    id: data?.codice.toString() || '',
    code: data?.codice.toString() || '',
    description: data?.descrizione || '',
  };
  return res;
};
